module.exports = __webpack_public_path__ + "img/ltkasia-1x.6a052f9.jpg";